import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CSpinner } from '@coreui/react';

import { ToastProvider } from './context/ToastContext';
import './App.scss';

// ── Lazy imports ──────────────────────────────────────────────────────────────
const AppLayout    = React.lazy(() => import('./layout/AppLayout'));
const Landing      = React.lazy(() => import('./views/Pages/Landing/Landing'));
const Login        = React.lazy(() => import('./views/Pages/Login/Login'));
const Register     = React.lazy(() => import('./views/Pages/Register/Register'));
const VerifyEmail   = React.lazy(() => import('./views/Pages/VerifyEmail/VerifyEmail'));
const JoinInvitation = React.lazy(() => import('./views/Pages/JoinInvitation/JoinInvitation'));
const SelectTenant  = React.lazy(() => import('./views/Pages/SelectTenant/SelectTenant'));

const Loader = () => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center">
    <CSpinner color="primary" />
  </div>
);

const App = () => (
  <BrowserRouter>
    <ToastProvider>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/"                element={<Landing />} />
          <Route path="/login"          element={<Login />} />
          <Route path="/register"       element={<Register />} />
          <Route path="/verify-email"   element={<VerifyEmail />} />
          <Route path="/join-invitation" element={<JoinInvitation />} />
          <Route path="/select-tenant"  element={<SelectTenant />} />
          <Route path="/*"              element={<AppLayout />} />
        </Routes>
      </Suspense>
    </ToastProvider>
  </BrowserRouter>
);

export default App;
